import axios from '@/axios.js'

let entityURL = 'users'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = {'Authorization': `bearer ${token}`}

// State
const state = {
    isRegistered: false,
    namespaced: true,
    // All users
    records: [],
    // One User
    record: {},
    // display pop up (Modal)
    displayPopUp: false,
    popUpTitle: '',
    declineCodes: [
        { code : 'authentication_required', description: 'The card was declined as the transaction requires authentication.', elDescription: 'Η κάρτα απορρίφθηκε καθώς η συναλλαγή απαιτεί έλεγχο ταυτότητας.', },
        { code : 'approve_with_id', description: 'The payment cannot be authorized.', elDescription: 'Δεν είναι δυνατή η έγκριση της πληρωμής.', },
        { code : 'call_issuer', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'card_not_supported', description: 'The card does not support this type of purchase.', elDescription: 'Η κάρτα δεν υποστηρίζει αυτόν τον τύπο αγοράς.', },
        { code : 'card_velocity_exceeded', description: 'The customer has exceeded the balance or credit limit available on their card.', elDescription: 'Ο πελάτης έχει ξεπεράσει το υπόλοιπο ή το πιστωτικό όριο που είναι διαθέσιμο στην κάρτα του.', },
        { code : 'currency_not_supported', description: 'The card does not support the specified currency.', elDescription: 'Η κάρτα δεν υποστηρίζει το καθορισμένο νόμισμα.', },
        { code : 'do_not_honor', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'do_not_try_again', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'duplicate_transaction', description: 'A transaction with identical amount and credit card information was submitted very recently.', elDescription: 'Πολύ πρόσφατα υποβλήθηκε μια συναλλαγή με το ίδιο ποσό και στοιχεία πιστωτικής/χρεωστική κάρτας.', },
        { code : 'expired_card', description: 'The card has expired.', elDescription: 'Η κάρτα έχει λήξει.', },
        { code : 'fraudulent', description: 'The payment has been declined as Stripe suspects it is fraudulent.', elDescription: 'Η πληρωμή απορρίφθηκε καθώς η Stripe υποπτεύεται ότι είναι δόλια.', },
        { code : 'generic_decline', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'incorrect_number', description: 'The card number is incorrect.', elDescription: 'Ο αριθμός κάρτας είναι λανθασμένος.', },
        { code : 'incorrect_cvc', description: 'The CVC number is incorrect.', elDescription: 'Ο αριθμός CVC είναι λανθασμένος.', },
        { code : 'incorrect_pin', description: 'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.', elDescription: 'Το PIN που εισαγάγατε είναι λανθασμένο. Αυτός ο κωδικός απόρριψης ισχύει μόνο για πληρωμές που πραγματοποιούνται με αναγνώστη καρτών.', },
        { code : 'incorrect_zip', description: 'The ZIP/postal code is incorrect.', elDescription: 'Ο ταχυδρομικός κώδικας δεν είναι σωστός.', },
        { code : 'insufficient_funds', description: 'The card has insufficient funds to complete the purchase.', elDescription: 'Η κάρτα δεν διαθέτει επαρκή χρήματα για την ολοκλήρωση της αγοράς.', },
        { code : 'invalid_account', description: 'The card, or account the card is connected to, is invalid.', elDescription: 'Η κάρτα ή ο λογαριασμός στον οποίο είναι συνδεδεμένη η κάρτα δεν είναι έγκυρη.', },
        { code : 'invalid_amount', description: 'The payment amount is invalid, or exceeds the amount that is allowed.', elDescription: 'Το ποσό πληρωμής δεν είναι έγκυρο ή υπερβαίνει το επιτρεπόμενο ποσό.', },
        { code : 'invalid_cvc', description: 'The CVC number is incorrect.', elDescription: 'Ο αριθμός CVC είναι λανθασμένος.', },
        { code : 'invalid_expiry_month', description: 'The expiration month is invalid.', elDescription: 'Ο μήνας λήξης δεν είναι έγκυρος.', },
        { code : 'invalid_expiry_year', description: 'The expiration year is invalid.', elDescription: 'Το έτος λήξης δεν είναι έγκυρο.', },
        { code : 'invalid_number', description: 'The card number is incorrect.', elDescription: 'Ο αριθμός κάρτας είναι λανθασμένος.', },
        { code : 'invalid_pin', description: 'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.', elDescription: 'Το PIN που εισαγάγατε είναι λανθασμένο. Αυτός ο κωδικός απόρριψης ισχύει μόνο για πληρωμές που πραγματοποιούνται με αναγνώστη καρτών.', },
        { code : 'issuer_not_available', description: 'The card issuer could not be reached, so the payment could not be authorized.', elDescription: '', },
        { code : 'lost_card', description: 'The payment has been declined because the card is reported lost.', elDescription: 'Η πληρωμή απορρίφθηκε επειδή αναφέρεται ότι η κάρτα έχει χαθεί.', },
        { code : 'merchant_blacklist', description: 'The payment has been declined because it matches a value on the Stripe user’s block list.', elDescription: 'Η πληρωμή απορρίφθηκε επειδή αντιστοιχεί σε μια τιμή στη λίστα αποκλεισμού του χρήστη Stripe.', },
        { code : 'new_account_information_available', description: 'The card, or account the card is connected to, is invalid.', elDescription: 'Η κάρτα ή ο λογαριασμός στον οποίο είναι συνδεδεμένη η κάρτα δεν είναι έγκυρη.', },
        { code : 'no_action_taken', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'not_permitted', description: 'The payment is not permitted.', elDescription: 'Η πληρωμή δεν επιτρέπεται.', },
        { code : 'offline_pin_required', description: 'The card has been declined as it requires a PIN.', elDescription: 'Η κάρτα έχει απορριφθεί καθώς απαιτεί PIN.', },
        { code : 'online_or_offline_pin_required', description: 'The card has been declined as it requires a PIN.', elDescription: 'Η κάρτα έχει απορριφθεί καθώς απαιτεί PIN.', },
        { code : 'pickup_card', description: 'The card cannot be used to make this payment (it is possible it has been reported lost or stolen).', elDescription: 'Η κάρτα δεν μπορεί να χρησιμοποιηθεί για την πραγματοποίηση αυτής της πληρωμής (είναι πιθανό να έχει αναφερθεί απώλεια ή κλοπή).', },
        { code : 'pin_try_exceeded', description: 'The allowable number of PIN tries has been exceeded.', elDescription: 'Έχει γίνει υπέρβαση του επιτρεπόμενου αριθμού προσπαθειών PIN.', },
        { code : 'processing_error', description: 'An error occurred while processing the card.', elDescription: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία της κάρτας.', },
        { code : 'reenter_transaction', description: 'The payment could not be processed by the issuer for an unknown reason.', elDescription: 'Δεν ήταν δυνατή η επεξεργασία της πληρωμής από τον εκδότη για άγνωστο λόγο.', },
        { code : 'restricted_card', description: 'The card cannot be used to make this payment (it is possible it has been reported lost or stolen).', elDescription: 'Η κάρτα δεν μπορεί να χρησιμοποιηθεί για την εκτέλεση αυτής της πληρωμής (είναι πιθανό να έχει αναφερθεί απώλεια ή κλοπή).', },
        { code : 'revocation_of_all_authorizations', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'revocation_of_authorization', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'security_violation', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'service_not_allowed', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'stolen_card', description: 'The payment has been declined because the card is reported stolen.', elDescription: 'Η πληρωμή απορρίφθηκε επειδή αναφέρεται ότι η κάρτα έχει κλαπεί.', },
        { code : 'stop_payment_order', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'testmode_decline', description: 'A Stripe test card number was used.', elDescription: 'Χρησιμοποιήθηκε ένας αριθμός κάρτας δοκιμής Stripe.', },
        { code : 'transaction_not_allowed', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'try_again_later', description: 'The card has been declined for an unknown reason.', elDescription: 'Η κάρτα απορρίφθηκε για άγνωστο λόγο.', },
        { code : 'withdrawal_count_limit_exceeded', description: 'The customer has exceeded the balance or credit limit available on their card.', elDescription: 'Ο πελάτης έχει ξεπεράσει το υπόλοιπο ή το πιστωτικό όριο που είναι διαθέσιμο στην κάρτα του.', },
    ],
    clientSecret: null
}

// Getters
const getters = {
    getIsRegistered: (state) => (state.isRegistered),
    getNamespaced: (state) => (state.namespaced),
    getUsers: (state) => (state.records),
    getUser: (state) => (state.record),
    getDisplayPopUp: (state) => (state.displayPopUp),
    getPopUpTitle: (state) => (state.popUpTitle),
    getDeclineCodes: ( state ) => state.declineCodes,
    getClientSecret: (state) => state.clientSecret
}

// Actions
const actions = {

    // Add user user
    async addNewUser({commit}, item) {
        const response = await axios.post(`${entityURL}/add`, item)
        commit('ADD_ITEM', response.data.object)
    },

    // Fetch users
    async fetchUsers({commit}) {
        const response = await axios(`${entityURL}/list`)
        commit('SET_RECORDS', response.data)
    },

    // Fetch user
    async fetchUser({commit}, recordId) {
        const response = await axios.get(`${entityURL}/get/${recordId}`)
        commit('SET_RECORD', response.data)
    },

    async removeOrphanLinks({commit}) {
        const response = await axios.get(`remove-orphan-links`)
    },

    // Edit user
    async editUser({commit}, item) {
        const response = await axios.put(`${entityURL}/update/${item.id}`, item)
        commit('UPDATE_ITEM', response.data.object)
    },

    // Delete user
    async removeUser({commit}, recordId) {
        const response = await axios.delete(`${entityURL}/delete/${recordId}`)
        if (response.data.message === 'Successfully Deleted') {
            commit('REMOVE_RECORD', recordId)
        }
    },

    async paymentProcess({commit}, payload) {
        const response = await axios.post(`payment-attempt`, payload)
        commit('SET_CLIENT_SECRET', response.data.output.clientSecret)
    },

    displayUserPopUp({commit}, payload) {
        commit('DISPLAY_POP_UP', payload)
    },

    setUserPopUpTitle({commit}, payload){
        commit('SET_POP_UP_TITLE', payload)
    },

    userSetter({commit}, payload){
        commit('USER_SETTER', payload)
    },

    setUserName({commit}, value){
        commit('SET_USER_NAME', value)
    },

    setUserLastName({commit}, value){
        commit('SET_USER_LAST_NAME', value)
    },

    setUserUsername({commit}, value){
        commit('SET_USER_USERNAME', value)
    },

    setUserEmail( {commit}, value){
        commit('SET_USER_EMAIL', value)
    },

    setUserPassword({commit}, value){
        commit('SET_USER_PASSWORD', value)
    },

    setUserRole({commit}, value){
      commit('SET_USER_ROLE', value)
    },

    setUserIsActive({commit}, value){
        commit('SET_USER_IS_ACTIVE', value)
    },
    setUserSendMassiveEmail({commit}, value){
        commit('SET_USER_SEND_MASSIVE_EMAIL', value)
    },
    setUserSendOnlyChanges({commit}, value){
        commit('SET_USER_SEND_ONLY_CHANGES', value)
    },

    async addRequestsToClient({commit}, payload) {
        const response = await axios.post(`add-request-to-client`, payload)
    },
}

// Mutations
const mutations = {
    // Add new user
    ADD_ITEM: (state, item) => (state.records.push(item)),

    // Set Users
    SET_RECORDS: (state, data) => (state.records = data),

    // Set User
    SET_RECORD: (state, data) => (state.record = data),

    // Update user
    UPDATE_ITEM(state, item) {
        const recordIndex = state.records.findIndex((p) => p.id === item.id)
        if (recordIndex !== -1) {
            state.records.splice(recordIndex, 1, item);
            state.record = item;
        }
    },

    // Delete user
    REMOVE_RECORD: (state, itemId) => {
        const recordIndex = state.records.findIndex((u) => u.id === itemId)
        state.records.splice(recordIndex, 1)
    },
    DISPLAY_POP_UP:( state, data) => ( state.displayPopUp = data),
    SET_POP_UP_TITLE:( state, data ) => (state.popUpTitle = data),
    USER_SETTER: ( state, data ) => ( state.record = data),
    SET_USER_NAME: ( state, data ) => (state.record.name = data),
    SET_USER_LAST_NAME: ( state, data ) => (state.record.surname = data),
    SET_USER_USERNAME: ( state, data ) => (state.record.username = data),
    SET_USER_EMAIL: ( state, data ) => (state.record.email = data),
    SET_USER_PASSWORD: ( state, data ) => (state.record.password = data),
    SET_USER_ROLE: ( state, data ) => (state.record.role = data),
    SET_USER_IS_ACTIVE: ( state, data ) => (state.record.isActive = data),
    SET_CLIENT_SECRET: ( state, data ) => (state.clientSecret = data),
    SET_USER_SEND_MASSIVE_EMAIL: ( state, data ) => (state.record.sendMassiveEmail = data),
    SET_USER_SEND_ONLY_CHANGES: ( state, data ) => (state.record.sendOnlyChanges = data),
}

export default {state, getters, actions, mutations}
